import { queryLiveDataByCustompage } from "@/api/live";
import { LivePlayer } from "@/components/live";
import exposure from "@/utils/expose/exposure";
import Track from "@/utils/track";
import useNavigation from "@/utils/useNavigate";
import React, { useEffect, useState } from "react";
import LiveDesc from "../live-desc";
import LiveStatus from "../live-status";
import styles from "./index.module.less";

interface Live_1_1Props {
  componentInfo?: any;
  pageData?: any;
  resourceRank?: any;
}

const Live_1_1: React.FC<Live_1_1Props> = ({ componentInfo, pageData, resourceRank }) => {
  const track = Track();
  const [liveData, setLiveData] = useState<any>(null);
  const { navigate2LiveItem } = useNavigation();

  useEffect(() => {
    if (!componentInfo) {
      return;
    }
    queryLiveDataByCustompage({ ...componentInfo }).then(res => {
      setLiveData(res?.[0] || null);
    });
  }, [componentInfo]);

  useEffect(() => {
    const interval = setInterval(() => {
      let flag = false;
      const dom = document.getElementById(`live-${liveData?.liveNo}`);
      if (dom) {
        exposure.add({
          el: dom,
        });
      } else {
        flag = true;
      }
      if (!flag) {
        clearInterval(interval);
      }
    }, 1000);
  }, [liveData]);

  const handleClick = (item: any, index: number) => {
    const { liveStatus } = item || {};
    track.track("resource_click", {
      page_name: pageData?.name,
      resource_type: "直播",
      resource_content: "直播",
      resource_rank: resourceRank,
      relativeRank: index + 1,
      domain: "CONFERENCE3",
      market_id: pageData?.pageCode,
      live_name: item?.liveTitle,
      live_type: item?.liveType,
      live_status: liveStatus === 20 ? "直播中" : liveStatus === 10 ? "直播预告" : "直播结束",
      live_no: item?.liveNo,
      btn_name: "查看直播",
    });
    navigate2LiveItem(liveData);
  };

  return (
    <>
      {[10, 20].includes(liveData?.liveStatus) ||
      (liveData?.liveStatus > 20 && liveData?.playBackUrl) ? (
        <div
          id={`live-${liveData?.liveNo}`}
          className={styles.card}
          data-param={JSON.stringify({
            page_name: pageData?.name,
            resource_type: "直播",
            resource_content: "直播",
            resource_rank: resourceRank,
            relativeRank: 1,
            domain: "CONFERENCE3",
            market_id: pageData?.pageCode,
            live_name: liveData?.liveTitle,
            live_type: liveData?.liveType,
            live_status:
              liveData?.liveStatus === 20
                ? "直播中"
                : liveData?.liveStatus === 10
                  ? "直播预告"
                  : "直播结束",
            live_no: liveData?.liveNo,
          })}
          onClick={() => {
            handleClick(liveData, 0);
          }}>
          <div className={styles.card__body}>
            <LiveStatus liveData={liveData} />
            {liveData?.liveStatus !== 20 ? (
              <div className={styles.body__mask}>
                <img className={styles.mask__img} src={liveData?.liveCover || liveData?.coverUrl} />
              </div>
            ) : (
              <LivePlayer
                roomId={liveData?.liveNo}
                className={styles.live}
                muted={true}
                onError={error => {
                  console.log("播放器报错", error);
                }}
                poster={liveData?.liveCover || liveData?.coverUrl}
                supportClick={false}
                mutedVisible={false}
                showPlayBtn={false}
              />
            )}
          </div>
          <div className={styles.card__footer}>
            <span className={styles.footer__left}>{(liveData?.liveTitle || "").slice(0, 20)}</span>
            <span className={styles.footer__right}>
              <LiveDesc
                iconName={liveData?.liveLabelInfo?.iconName}
                showText={liveData?.liveLabelInfo?.showText}
              />
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Live_1_1;
